import header from "./header";
import footer from "./footer";
const lang = {
  header: {
    ...header,
  },
  footer: {
    ...footer,
  },
};

export default lang;
